<template>
<v-dialog
    v-model="dialog"
    max-width="600"
>
    <v-card>
    <v-card-title class="headline">Forward Incoming Phone Calls</v-card-title>

    <v-card-text>

        <v-select
            label="Forward incoming calls to"
            :items=choices
            v-model="active_choice"
            return-object
        />

    </v-card-text>

    <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn
            color="gray darken-1"
            text
            @click="dialog = false"
        >
        Cancel
        </v-btn>

        <v-btn
            color="primary darken-1"
            text
            @click="onOk"
        >
        Ok
        </v-btn>
    </v-card-actions>
    </v-card>
</v-dialog>
</template>

<script>

const E164 = require('@/js/E164.js');



export default {
    data() {
        return {
            dialog: false, 

            choices: [],
            active_choice: {},
        }
    },

    methods: 
    {
        showDialog(profile) 
        {
            let choices = [];
            let active_choice = null;

            let personal_devices = profile.employee_account.personal_devices;
            let forward_incoming_calls = profile.employee_account.voice_settings.forward_incoming_calls;

            for ( let i = 0; i < personal_devices.length; i++ )
            {
                let cur_endpoint = personal_devices[i].endpoint;
                let pretty_print = E164.prettyPrintUsPhoneNumber(cur_endpoint);

                choices.push({
                    'text' : pretty_print+" ("+personal_devices[i].label+")",
                    'value' : cur_endpoint
                });

                if ( forward_incoming_calls === cur_endpoint )
                    active_choice = choices[choices.length-1];
            }

            if ( forward_incoming_calls !== null && active_choice == null )
            {
                let pretty_print = E164.prettyPrintUsPhoneNumber(forward_incoming_calls);

                choices.push({
                    'text' : pretty_print+" (Custom)",
                    'value' : forward_incoming_calls
                });

                active_choice = choices[choices.length-1];
            }

            choices.push({
                    'text' : 'Custom Phone Number...',
                    'value' : 'custom'
                });

            choices.push({
                    'text' : 'Do not forward incoming calls',
                    'value' : 'do_not_forward'
                });

            if ( forward_incoming_calls === null )
                    active_choice = choices[choices.length-1];
            
            this.choices = choices;
            this.active_choice = active_choice;
            this.dialog = true;
        },
        
        onOk()
        {
           this.dialog = false;

            let voice_settings = {
                'forward_incoming_calls' : this.active_choice.value,
            };

            if ( !voice_settings.forward_incoming_calls.startsWith('E164') )
                voice_settings.forward_incoming_calls = null;

           this.$emit('ok', voice_settings);
        }
    },

    watch: {
        active_choice(newValue, oldValue) 
        {
            if ( newValue == null ) return;

            if ( newValue.value === 'custom' )
            {
                let value = prompt("Enter the phone number to forward incoming phone calls to");
                let endpoint = E164.createEndpointFromUSPhoneNumber(value,null);

                if ( endpoint == null )
                {
                    setTimeout(() => { this.active_choice = oldValue; }, 100);
                    return;
                }

                let new_item = {
                    'text' : E164.prettyPrintUsPhoneNumber(endpoint)+" (Custom)",
                    'value' : endpoint
                };

                this.choices.splice(this.choices.length-2,0,new_item);

                setTimeout(() => { this.active_choice = new_item; }, 100);
            }    
        }
    },
}
</script>

<style lang="scss" scoped>

</style>